<script>
    // ═══ КАРТОЧКА ЗАБИВА В ХУДЕ ═══
    // Висит у обеих банд с момента забива и до конца боя: этап, обратный отсчёт,
    // счёт живых. Положение настраивается в редакторе худа (блок «gangwar»).
    import { fly } from 'svelte/transition';
    import { hudEditMode } from 'store/hudlayout'
    import HudBox from './hudbox.svelte'

    let war = null;

    window.hudStore.gangwar = (json) => {
        try {
            const d = typeof json === 'string' ? JSON.parse(json) : json;
            war = (d && d.on) ? d : null;
        } catch (e) { war = null; }
    };

    // демо для редактора худа
    const DEMO = {
        on: true, stage: 3, title: 'Идёт бой', seconds: 428,
        biz: 'Магазин 24/7', atk: 'Bloods', def: 'Ballas',
        caliber: 'Автоматы', size: 5, atkAlive: 4, defAlive: 3, me: 'atk', joined: true,
        startAt: '23:40',
    };
    let demo = false;
    let demoTimer = null;
    window.hudStore.demoGangwar = () => {
        demo = true;
        if (demoTimer) clearTimeout(demoTimer);
        demoTimer = setTimeout(() => { demo = false; demoTimer = null; }, 10000);
    };
    $: if (!$hudEditMode && demo) {
        demo = false;
        if (demoTimer) { clearTimeout(demoTimer); demoTimer = null; }
    }

    $: view = war || ((demo || $hudEditMode) ? DEMO : null);
    $: mm = view ? String(Math.floor(view.seconds / 60)).padStart(2, '0') : '00';
    $: ss = view ? String(view.seconds % 60).padStart(2, '0') : '00';
    $: hot = view && view.stage === 3;
    $: mine = view && view.me === 'atk';
</script>

{#if view}
<HudBox id="gangwar" label="забив">
    <div class="gw" class:hot transition:fly={{ x: -20, duration: 300 }}>
        <div class="gw-hair"></div>

        <div class="gw-top">
            <span class="gw-kick">Война за бизнес</span>
            <span class="gw-biz">{view.biz}</span>
        </div>

        <div class="gw-teams">
            <div class="gw-team atk" class:me={mine}>
                <span class="gw-tname">{view.atk}</span>
                <b class="gw-alive">{view.atkAlive}</b>
            </div>
            <div class="gw-mid">
                <span class="gw-clock">{mm}:{ss}</span>
                <span class="gw-stage">{view.title}</span>
            </div>
            <div class="gw-team def" class:me={!mine}>
                <span class="gw-tname">{view.def}</span>
                <b class="gw-alive">{view.defAlive}</b>
            </div>
        </div>

        <div class="gw-bottom">
            <span>{view.caliber} · {view.size} на {view.size}</span>
            {#if view.stage === 0}
                <span class="gw-hint">старт в {view.startAt}</span>
            {:else if view.stage === 1}
                <span class="gw-hint gold">{view.joined ? 'вы на арене' : 'метка входа на бизнесе'}</span>
            {:else if view.stage === 2}
                <span class="gw-hint gold">подготовка</span>
            {/if}
        </div>
    </div>
</HudBox>
{/if}

<style>
    .gw {
        position: relative; width: 30vh; box-sizing: border-box;
        padding: 1.1vh 1.4vh 1.2vh; border-radius: 1.3vh; overflow: hidden;
        background: linear-gradient(150deg, rgba(18, 15, 12, 0.96), rgba(11, 10, 9, 0.93));
        border: 1px solid rgba(231, 174, 63, 0.36);
        box-shadow: 0 1.2vh 3.4vh rgba(0, 0, 0, 0.55);
        font-family: 'Manrope', 'Gilroy', sans-serif;
    }
    .gw.hot { border-color: rgba(240, 86, 83, 0.55); }
    .gw-hair { position: absolute; top: 0; left: 1.4vh; right: 1.4vh; height: 1px;
        background: linear-gradient(90deg, transparent, rgba(231, 174, 63, 0.7), transparent); }
    .gw.hot .gw-hair { background: linear-gradient(90deg, transparent, rgba(240, 86, 83, 0.8), transparent); }

    .gw-top { display: flex; align-items: baseline; justify-content: space-between; gap: .8vh; margin-bottom: .8vh; }
    .gw-kick { font-size: .8vh; font-weight: 800; letter-spacing: .2em; text-transform: uppercase; color: #e7ae3f; }
    .gw-biz { font-size: 1.1vh; font-weight: 700; color: rgba(243, 234, 214, 0.65);
        overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 15vh; }

    .gw-teams { display: flex; align-items: center; justify-content: space-between; gap: .6vh; }
    .gw-team { flex: 1; min-width: 0; display: flex; flex-direction: column; align-items: center; gap: .15vh;
        padding: .5vh .3vh; border-radius: .8vh; border: 1px solid transparent; }
    .gw-team.me { background: rgba(231, 174, 63, 0.08); border-color: rgba(231, 174, 63, 0.28); }
    .gw-tname { font-size: .95vh; font-weight: 700; color: rgba(243, 234, 214, 0.6);
        overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 9vh; }
    .gw-alive { font-size: 2vh; font-weight: 900; line-height: 1; color: #fff; }
    .gw-team.atk .gw-alive { color: #e7ae3f; }
    .gw-team.def .gw-alive { color: #f05653; }

    .gw-mid { flex-shrink: 0; display: flex; flex-direction: column; align-items: center; }
    .gw-clock { font-size: 1.9vh; font-weight: 900; color: #fff; letter-spacing: .04em; }
    .gw.hot .gw-clock { color: #f7b3ae; }
    .gw-stage { font-size: .8vh; font-weight: 700; letter-spacing: .1em; text-transform: uppercase;
        color: rgba(243, 234, 214, 0.42); white-space: nowrap; }

    .gw-bottom { display: flex; align-items: baseline; justify-content: space-between; gap: .8vh;
        margin-top: .8vh; padding-top: .7vh; border-top: 1px solid rgba(255, 255, 255, 0.07);
        font-size: .95vh; font-weight: 700; color: rgba(243, 234, 214, 0.45); }
    .gw-hint { white-space: nowrap; }
    .gw-hint.gold { color: #e7ae3f; }
</style>
